import axios from "axios";
import React, { useState, useEffect } from "react";
import { Form, Button } from "react-bootstrap";
//import { createUser } from "../services/createUser";
import { Link } from "react-router-dom";
import { environment } from "../../environment";
import Select from "react-select";
import { Country, State, City } from "country-state-city";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import NavbarNew from "../Components/NavbarNew";

const MySwal = withReactContent(Swal);

const EditLogisticManager = ({ history, match }) => {
  const [dap_firstName, setFirstName] = useState("");
  const [dap_lastName, setLastName] = useState("");
  const [dap_phone, setPhone] = useState("");
  const [dap_email, setEmail] = useState("");
  const [dap_address, setAddress] = useState("");
  const [dap_city, setDapCity] = useState([]);
  const [dap_states, setDapState] = useState([]);
  const [countrycode, setCountryCode] = useState("");
  const [postcountry, setPostCountry] = useState("");
  const [dap_countries, setDapCountries] = useState("");
  const [poststate, setPostState] = useState("");
  const [zip, setZip] = useState("");
  const [postcity, setPostCity] = useState("");
  const [dap_groupEntityId, setGroupEntityId] = useState("");
  const [loading, setLoading] = useState(false);
  const [dap_users, setUsers] = useState([]);
  //const [loader, setLoader] = useState(true);

  const [edit_country, setCountry] = useState("");
  const [edit_state, setState] = useState("");
  const [edit_city, setCity] = useState("");

  const [emailErrors, setEmailErrors] = useState({});
  const [nameErrors, setNameErrors] = useState({});
  const [lastNameErrors, setLastNameErrors] = useState({});

  const c_id = localStorage.getItem("c_id");

  const dap_user_id = match.params.id;
  const [dap_tenantId, setTenantId] = useState("");
  let countries = [];
  let states = [];
  countries = Country.getAllCountries();
  states = State.getAllStates();
  const selectCountry = (e) => {
    setDapCountries(Country.getAllCountries());
    setDapState(State.getStatesOfCountry(e.id));
    setCountryCode(e.id);
    setPostCountry(e.label);
    setCountry(e.label);
  };

  const selectRegion = (e) => {
    setDapCity(City.getCitiesOfState(countrycode, e.id));
    setPostState(e.label);
    setState(e.label);
  };
  const selectCity = (e) => {
    setPostCity(e.label);
    setCity(e.label);
  };

  useEffect(() => {
    // let userDetails = "";
    // userDetails = localStorage.getItem("userDetails");
    // userDetails = JSON.parse(userDetails);
    // console.log("hyyy there", userDetails.data.tenantId.id);
    // setTenantId(userDetails.data.tenantId.id);
    let id = match.params.id;
    // getLogisticManager(id);
    console.log(id);
    axios
      .get(environment.dap_url + "logisticManager/getDetailsById?id=" + id)
      .then((res) => {
        // const dap_users = res.data.data;
        console.log(res);
        console.log("hello");
        // setUsers(res.data.data);
        setEmail(res.data.email);
        setFirstName(res.data.userFirstName);
        setLastName(res.data.userLastName);
        setPhone(res.data.phone);
        setAddress(res.data.address);
        setCountry(res.data.country);
        setPostCountry(res.data.country);
        setState(res.data.state);
        setPostState(res.data.state);
        setCity(res.data.city);
        setPostCity(res.data.city);
        // setDapState(res.data.state);
        // setDapCity(res.data.city);
        // setPostCountry(res.data.country);

        // console.log(res.data.data);
        // setLoader(false);
      })
      .catch(function (error) {
        MySwal.fire({
          title: <p>{error.message}</p>,
          type: "error",
        });
      });
  }, []);

  const formValidation = () => {
    const emailErrors = {};
    const nameErrors = {};
    const lastNameErrors = {};
    let isValid = true;

    if (!dap_email) {
      emailErrors.noEmail = "* Email Id required";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(dap_email)) {
      emailErrors.invalidEmail = "* Email address is invalid";
      isValid = false;
    }
    if (!dap_firstName) {
      nameErrors.noName = "* First Name is required";
      isValid = false;
    } else if (dap_firstName.trim().length < 2) {
      nameErrors.shortName = "* Name is too short";
      isValid = false;
    } else if (dap_firstName.trim().length > 30) {
      nameErrors.shortName = "* Name is too long";
      isValid = false;
    }

    if (!dap_lastName) {
      lastNameErrors.noName = "* Last Name is required";
      isValid = false;
    } else if (dap_lastName.trim().length < 2) {
      lastNameErrors.shortName = "* Name is too short";
      isValid = false;
    } else if (dap_lastName.trim().length > 30) {
      lastNameErrors.shortName = "* Name is too long";
      isValid = false;
    }

    setEmailErrors(emailErrors);

    setNameErrors(nameErrors);
    setLastNameErrors(lastNameErrors);
    return isValid;
  };

  const submitHandler = (e) => {
    const isValid = formValidation();
    e.preventDefault();
    setLoading(true);
    let id = match.params.id;

    if (!isValid) {
      setLoading(false);
      return;
    }

    axios
      .put(environment.dap_url + "logisticManager/update", {
        id: match.params.id,
        email: dap_email,
        userFirstName: dap_firstName,
        userLastName: dap_lastName,
        phone: dap_phone,
        country: postcountry,
        state: poststate,
        city: postcity,
        address: dap_address,
      })
      .then((res) => {
        console.log(res);
        console.log("hello");
        history.push("/logisticmanagers");
        MySwal.fire({
          title: <p>Logistic Manager has been successfully updated!</p>,
          type: "success",
        });
      })
      .catch((err) => {
        setLoading(false);
        MySwal.fire({
          title: (
            <p>
              {err?.response?.data?.message || "Logistic Manager update failed"}
            </p>
          ),
          type: "error",
        });
      });
  };

  return (
    <>
      <div className="container-fluid">
        <NavbarNew />
        <div className="row">
          <div className="col-lg-6">
            <Link to={`/logisticmanagers`} className="btn btn-light my-3">
              Go Back
            </Link>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-3"></div>
          <div className="col-md-6 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <h1 className="text-center">EDIT LOGISTIC MANAGER</h1>
                <Form onSubmit={submitHandler}>
                  <Form.Group controlId="title">
                    <Form.Label>* Email</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Enter Email"
                      value={dap_email}
                      onChange={(e) => setEmail(e.target.value)}
                      readOnly
                    ></Form.Control>
                    <div>
                      {Object.keys(emailErrors).map((key) => {
                        return (
                          <div style={{ color: "red" }}>{emailErrors[key]}</div>
                        );
                      })}
                    </div>
                  </Form.Group>

                  <Form.Group controlId="title">
                    <Form.Label>* First Name</Form.Label>
                    <Form.Control
                      type="userFirstName"
                      placeholder="Enter First Name"
                      value={dap_firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                    ></Form.Control>
                    <div>
                      {Object.keys(nameErrors).map((key) => {
                        return (
                          <div style={{ color: "red" }}>{nameErrors[key]}</div>
                        );
                      })}
                    </div>
                  </Form.Group>

                  <Form.Group controlId="userLastName">
                    <Form.Label>* Last Name</Form.Label>
                    <Form.Control
                      type="userLastName"
                      placeholder="Enter Last Name"
                      value={dap_lastName}
                      onChange={(e) => setLastName(e.target.value)}
                    ></Form.Control>
                    <div>
                      {Object.keys(lastNameErrors).map((key) => {
                        return (
                          <div style={{ color: "red" }}>
                            {lastNameErrors[key]}
                          </div>
                        );
                      })}
                    </div>
                  </Form.Group>

                  <Form.Group controlId="phone">
                    <Form.Label>Phone</Form.Label>
                    <Form.Control
                      type="phone"
                      placeholder="Add Phone"
                      value={dap_phone}
                      onChange={(e) => setPhone(e.target.value)}
                    ></Form.Control>
                  </Form.Group>
                  <div className="row">
                    <div className="col-4">
                      <Form.Group controlId="name">
                        <Form.Label>Country</Form.Label>
                        <Select
                          options={countries.map((element) => ({
                            id: element.isoCode,
                            value: element.name,
                            label: element.name,
                          }))}
                          onChange={(e) => selectCountry(e)}
                          // defaultValue={dap_deviceList[0].name}
                          // defaultValue="hi there"
                          value={{ label: edit_country }}
                          placeholder="Country"
                        />
                      </Form.Group>
                    </div>
                    <div className="col-4">
                      <Form.Group controlId="name">
                        <Form.Label>state</Form.Label>
                        <Select
                          options={dap_states.map((element) => ({
                            id: element.isoCode,
                            value: element.name,
                            label: element.name,
                          }))}
                          onChange={(e) => selectRegion(e)}
                          // defaultValue={dap_deviceList[0].name}
                          value={{ label: edit_state }}
                          defaultValue="hi there"
                          placeholder="State"
                        />
                      </Form.Group>
                    </div>
                    <div className="col-4">
                      <Form.Group controlId="name">
                        <Form.Label>City</Form.Label>
                        <Select
                          options={dap_city.map((element) => ({
                            id: element.isoCode,
                            value: element.name,
                            label: element.name,
                          }))}
                          onChange={(e) => selectCity(e)}
                          // defaultValue={dap_deviceList[0].name}
                          value={{ label: edit_city }}
                          defaultValue="hi there"
                          placeholder="State"
                        />
                      </Form.Group>
                    </div>
                  </div>

                  <Form.Group controlId="address">
                    <Form.Label>Address</Form.Label>
                    <Form.Control
                      type="address"
                      placeholder="Enter Address"
                      value={dap_address}
                      onChange={(e) => setAddress(e.target.value)}
                    ></Form.Control>
                  </Form.Group>

                  <div className="mt-3">
                    <Button
                      type="submit"
                      className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
                      disabled={loading}
                    >
                      SAVE
                      {loading && (
                        <i
                          className="fa fa-refresh fa-spin"
                          style={{ marginRight: "5px" }}
                        />
                      )}
                      {loading && <span></span>}
                      {!loading && <span></span>}
                    </Button>
                  </div>
                </Form>
              </div>
            </div>
          </div>
          <div className="col-lg-3"></div>
        </div>
      </div>
    </>
  );
};

export default EditLogisticManager;
